"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const antd_1 = require("antd");
const Title_1 = __importDefault(require("antd/lib/typography/Title"));
const suiteFormStyle_1 = require("./suiteFormStyle");
const FormSuite_1 = require("../../../hooks/FormSuite");
const helpers_1 = require("../../../utils/helpers");
const TelephoneStyle_1 = require("../../telephone/TelephoneStyle");
const data_repository_1 = require("../../../dataSource/data_repository");
const constants_1 = require("../../../assets/constants/constants");
const VehicleForm = ({ field, formKey = 'suites', parkingIsIncluded = false, vehicleIsRequired, setVehicleIsRequired, }) => {
    const { form } = (0, FormSuite_1.useFormSuit)();
    const [parkingIncluded, setParkingIncluded] = (0, react_1.useState)(false);
    const isAllEmpty = () => {
        if (vehicleIsRequired) {
            const vehicleFieldsToValidate = ['vehiclePlate', 'vehicleBrand', 'vehicleColor'];
            const allFieldsIsEmpty = vehicleFieldsToValidate.every(guestField => !form.getFieldValue([formKey, field.key, guestField]));
            if (allFieldsIsEmpty) {
                setVehicleIsRequired(false);
                form.validateFields([...vehicleFieldsToValidate.map(vechicleField => [formKey, field.key, vechicleField])]);
            }
            else {
                setVehicleIsRequired(true);
            }
        }
    };
    (0, react_1.useEffect)(() => {
        if (formKey === 'checkin') {
            setParkingIncluded(parkingIsIncluded || false);
        }
    }, [formKey, parkingIsIncluded]);
    (0, react_1.useEffect)(() => {
        if (formKey === 'suites' && !parkingIncluded) {
            const roomId = (0, helpers_1.decrypty)(localStorage.getItem('XP360:suite_roomId'));
            (0, data_repository_1.getRoom)(roomId)
                .then(response => {
                setParkingIncluded(response.room.features.find(({ feature }) => feature === constants_1.PARKING_FEATURE));
            })
                .catch(err => {
                // message.error('Ocorreu um erro ao carregar as comodidades.');
                console.error('Erro ', err);
            });
        }
    }, [formKey]);
    const plateTypeHandle = (0, react_1.useCallback)(name => {
        const formPlateTypeValue = form.getFieldValue([formKey]);
        formPlateTypeValue[name] = Object.assign(Object.assign({}, formPlateTypeValue[name]), { vehiclePlateType: name, vehiclePlate: '' });
        form.setFieldsValue({ [formKey]: formPlateTypeValue });
    }, [form, formKey]);
    return (react_1.default.createElement(react_1.default.Fragment, null, parkingIncluded && (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("hr", null),
        react_1.default.createElement(Title_1.default, { level: 5 }, "Ve\u00EDculo"),
        react_1.default.createElement(antd_1.Col, { span: 24 },
            react_1.default.createElement(antd_1.Row, { justify: "space-between" },
                react_1.default.createElement(antd_1.Col, { xs: {
                        span: 24,
                        flex: '1',
                    }, sm: {
                        span: 24,
                        flex: '1',
                    }, lg: 7 },
                    react_1.default.createElement(suiteFormStyle_1.FormItemFormulary, { labelCol: { span: 24 }, name: [field.name, 'vehicleBrand'], label: "Marca/Modelo", style: { color: '#000' }, rules: [
                            {
                                required: vehicleIsRequired,
                            },
                        ] },
                        react_1.default.createElement(suiteFormStyle_1.InputStyled, { onBlur: isAllEmpty, placeholder: "Marca e modelo do ve\u00EDculo" }))),
                react_1.default.createElement(antd_1.Col, { xs: {
                        span: 24,
                        flex: '1',
                    }, sm: {
                        span: 24,
                        flex: '1',
                    }, lg: 7 },
                    react_1.default.createElement(suiteFormStyle_1.FormItemFormulary, { labelCol: { span: 24 }, name: [field.name, 'vehicleColor'], label: "Cor", rules: [
                            {
                                required: vehicleIsRequired,
                            },
                        ] },
                        react_1.default.createElement(suiteFormStyle_1.InputStyled, { onBlur: isAllEmpty, placeholder: "Cor do ve\u00EDculo" }))),
                react_1.default.createElement(antd_1.Col, { xs: {
                        span: 24,
                        flex: '1',
                    }, sm: {
                        span: 24,
                        flex: '1',
                    }, lg: 7 },
                    react_1.default.createElement(antd_1.Row, { wrap: false },
                        react_1.default.createElement(suiteFormStyle_1.FormItemFormulary, { style: {
                                width: '110px',
                                maxWidth: '110px',
                                marginRight: '5px',
                                display: 'block',
                            }, labelCol: { span: 24 }, name: [field.name, 'vechiclePlateType'], label: "Modelo placa", initialValue: "default" },
                            react_1.default.createElement(TelephoneStyle_1.SelectStyled, { onChange: () => plateTypeHandle(field.name), size: "large" },
                                react_1.default.createElement(TelephoneStyle_1.SelectStyled.Option, { value: "default" }, "Padr\u00E3o"),
                                react_1.default.createElement(TelephoneStyle_1.SelectStyled.Option, { value: "mercosul" }, "Mercosul"))),
                        react_1.default.createElement(antd_1.Col, { flex: "1" },
                            react_1.default.createElement(suiteFormStyle_1.FormItemFormulary, { style: {
                                    flex: '1',
                                }, labelCol: { span: 24 }, name: [field.name, 'vehiclePlate'], label: "Placa", validateTrigger: "onBlur", rules: [
                                    {
                                        required: vehicleIsRequired,
                                    },
                                ] }, (() => {
                                switch (form.getFieldValue([formKey, field.key, 'vechiclePlateType'])) {
                                    case 'mercosul':
                                        return react_1.default.createElement(suiteFormStyle_1.MaskInputStyled, { mask: "AAA1A11", placeholder: "AAAXAXX", onBlur: isAllEmpty });
                                    default:
                                        return react_1.default.createElement(suiteFormStyle_1.MaskInputStyled, { mask: "AAA-1111", placeholder: "AAA-XXXX", onBlur: isAllEmpty });
                                }
                            })()))))))))));
};
exports.default = VehicleForm;
